/**
 * Scroll-triggered reveal animations via Intersection Observer.
 * Adds .micki-visible to .micki-reveal elements when they enter the viewport.
 * All animation logic is handled in CSS (micki-sections.css).
 */
(function () {
  function revealAll() {
    document.querySelectorAll('.micki-reveal:not(.micki-visible)').forEach(function (el) {
      el.classList.add('micki-visible');
    });
  }

  // Reduced motion: show all elements immediately, skip animation
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealAll();
    return;
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('micki-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.1
    }
  );

  function observeElements() {
    document.querySelectorAll('.micki-reveal:not(.micki-visible)')
      .forEach(function (el) {
        observer.observe(el);
      });
  }

  // Defer observation until after layout is stable
  if (document.readyState === 'complete') {
    observeElements();
  } else {
    window.addEventListener('load', observeElements);
  }

  // Re-observe after a short delay as a safety net
  // (covers edge cases where load fires before sections render)
  setTimeout(function () {
    observeElements();
    // Fallback: if observer still hasn't fired after 3s, reveal everything
    setTimeout(function () {
      var hidden = document.querySelectorAll('.micki-reveal:not(.micki-visible)');
      if (hidden.length > 0) {
        hidden.forEach(function (el) {
          el.classList.add('micki-visible');
        });
      }
    }, 3000);
  }, 100);

  // Expose observer for AJAX content replacement (collection filters, etc.)
  window.ToyBox = window.ToyBox || {};
  ToyBox.scrollObserver = observer;
  ToyBox.observeMickiReveals = observeElements;

  // Shopify editor: re-observe when sections are added dynamically
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', observeElements);
  }
})();
